<template>
  <div class="maintenance-group-status">
    <accordion-panel
      id="maintenance-group-status"
      :collapsed.sync="collapsed"
    >
      <template #title>
        {{ $t('engineering.cooling-maintenance.maintenance-group-status') }}
      </template>
      <s-table
        class="no-align"
        bordered
        :items="this.items"
        :fields="fields"
        :busy="loading">
        <template
          class="last-performance"
          #thead-top>
          <b-tr>
            <b-th
              colspan="1"
              rowspan="2">
              {{
                $t('fields.engineering.cooling-maintenance.state')
              }}
            </b-th>
            <b-th
              colspan="1"
              rowspan="2">
              {{
                $t('fields.engineering.cooling-maintenance.description')
              }}
            </b-th>
            <b-th
              class="text-center maintenance-group-status-no-border"
              colspan="3"
              rowspan="1"
              >
              {{ $t('fields.engineering.cooling-maintenance.last-performance') }}
            </b-th>
            <b-th
              colspan="1"
              rowspan="2">
              {{
                $t('fields.engineering.cooling-maintenance.days-since-last-maintenance')
              }}
            </b-th>
            <b-th
              colspan="1"
              rowspan="2">
              {{
                $t('fields.engineering.cooling-maintenance.total-maintenances')
              }}
            </b-th>
            <b-th
              colspan="1"
              rowspan="2">
              {{
                $t('fields.engineering.cooling-maintenance.total-days-service')
              }}
            </b-th>
            <b-th
              colspan="1"
              rowspan="2">
              {{
                $t('fields.engineering.cooling-maintenance.average-operation-time')
              }}
            </b-th>
            <b-th
              colspan="1"
              rowspan="2">
              {{
                // eslint-disable-next-line max-len
                $t('fields.engineering.cooling-maintenance.average-operation-time-since-last-maintenance')
              }}
            </b-th>
          </b-tr>
        </template>
        <template #cell(state)="data">
          <state-badge
            :value="data.value"
          />
        </template>
        <template #cell(description)="data">
          <strong>{{ getValidateField(data.value.toUpperCase()) }}</strong>
        </template>
        <template
          class="last-performance"
          #cell(start)="data">
          {{ getLastPerformanceStart(data) | dateTimeFilter({ format: formats.DATETIME_SHORT }) }}
        </template>
        <template
          class="last-performance"
          #cell(end)="data">
          {{ getLastPerformanceEnd(data) | dateTimeFilter({ format: formats.DATETIME_SHORT }) }}
        </template>
        <template
          class="last-performance"
          #cell(time)="data">
          {{ getValidateField(data.item.lastPerformance.time) }}
        </template>
        <template #cell(daysSinceLastMaintenance)="data">
          {{ getValidateField(data.value) }}
        </template>
        <template #cell(totalMaintenances)="data">
          {{ getValidateField(data.value) }}
        </template>
        <template #cell(totalDaysService)="data">
          {{ getValidateField(data.value) }}
        </template>
        <template #cell(averageOperationTime)="data">
          {{ getValidateField(data.value) }}
        </template>
        <template #cell(averageOperationTimeSinceLastMaintenance)="data">
          {{ getValidateField(data.value) }}
        </template>
      </s-table>
    </accordion-panel>
  </div>
</template>

<script>
import coolingMaintenanceGroupFields
  from '@/domain/data/installation/engineering/coolingMaintenance/coolingMaintenanceGroupFields.json';
import AccordionPanel from '@/components/AccordionPanel';
import StateBadge from '@/domain/components/installation/engineering/coolingMaintenance/general/StateBadge';
import { formats } from '@/constants/localizer';

export default {
  name: 'MaintenanceGroupStatus',
  props: {
    items: {
      type: Array,
      default: () => ([]),
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    AccordionPanel,
    StateBadge,
  },
  data: () => ({
    formats,
    collapsed: false,
  }),
  computed: {
    fields() {
      return coolingMaintenanceGroupFields.map(item => ({
        key: item.key,
        label: this.$t(item.label),
        thStyle: item.thStyle,
      }));
    },
  },
  methods: {
    getLastPerformanceStart(data) {
      return data?.item?.lastPerformance?.start;
    },
    getLastPerformanceEnd(data) {
      return data?.item?.lastPerformance?.end;
    },
    getValidateField(data) {
      if (data == null || data === '') { return '--'; }
      return data;
    },
  },
};
</script>

<style lang="sass" scoped>
@import "src/styles/defaults/variables"
.maintenance-group-status
  border: 1px solid $color-border-gray
  border-radius: 5px

  ::v-deep
    div.s-table
      border: 1px solid $color-border-gray
      border-radius: 4px
    .table-bordered th, .table-bordered td
      border: 2px solid var(--color-background-light)
      text-align: center
      min-width: 120px
      white-space: normal
      vertical-align: middle

    thead > tr > th.maintenance-group-status-no-border
      border-bottom: 2px solid transparent !important

    thead > tr > th[aria-colindex="3"],
    thead > tr > th[aria-colindex="4"]
      border-right: 2px solid transparent !important

    .accordion-panel
      box-shadow: none

      &__header
        padding: 2px 15px !important
        font-weight: bold

  @media print
    ::v-deep
      .table-bordered th, .table-bordered td
        min-width: auto
</style>
